import styled from "styled-components";

export const SearchAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ToolTipWrapper = styled.div`
  position: relative;
  .button {
    position: absolute;
  }
  &:hover {
    .tool-tip {
      display: block;
    }
  }
`;
export const ToolTip = styled.div`
  position: absolute;
  width: auto;
  height: 30px;
  background: #000000;
  border: 1px solid #38393c;
  border-radius: 4px;
  font-size: 14px;
  color: #a3b6ba;
  text-align: center;
  line-height: 30px;
  display: none;
  white-space: nowrap;
  top: -25px;
  padding: 0 10px;
  left: 0;
  margin-left: -140px;
`;
